import React, { useState, useEffect } from 'react'
import MainPage from '../../composents/MainPage'
import NumberFormatDecorator from '../../composents/NumberFormat'
import resources from '../../services'
import moment from 'moment/moment'

export const renderStyle = (data) => {
  let color = 'danger'
  if (data.type === 'sell') {
    color = 'warning'
  } else if (data.type === 'send') {
    color = 'success'
  } else if (data.type === 'request') {
    color = 'info'
  }

  return <label className={`form-label label label-${color}`}>{data.type}</label>
}

export const renderStatus = (data) => {
  let color = 'warning'
  let label = 'Pending'
  if (data.status === 2) {
    color = 'success'
    label = 'End'
  } else if (data.status === 3) {
    color = 'danger'
    label = 'Reject'
  } else if (moment(data.expire || moment()).isBefore(moment())) {
    color = 'danger'
    label = 'Expired'
  }

  return <label className={`form-label label label-${color}`}>{label}</label>
}
export default function Dashboard() {
  const [data, setData] = useState({}),
    [loading, setLoading] = useState(true)

  const getData = async () => {
    setLoading(true)
    const data = await resources.stats
      .dashborard()
      .then((responses) => {
        return responses
      })
      .catch((error) => {
        return Object.assign({}, error).response
      })

    if (data.status === 200) {
      setData(data.data)
    }

    setLoading(false)
  }

  useEffect(() => {
    getData()
  }, [])

  return (
    <MainPage show_header={false}>
      {loading ? (
        <div className="d-flex align-items-center justify-content-center">
          <div className="spinner-grow" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      ) : (
        <>
          <div className="col-xl-12 stat-text">
            <div className="card product-progress-card">
              <div className="card-block">
                <div className="row pp-main">
                  {data?.statsTop?.map((e, k) => (
                    <div key={k} className="col-xl-3 col-md-6">
                      <div className="pp-cont">
                        <div className="row align-items-center m-b-20">
                          <div className="col-auto">
                            <i className={`feather icon-${e.icon} f-24 text-mute`}></i>
                          </div>
                          <div className="col text-end">
                            <h2 className={`m-b-0 text-c-${e.color}`}>{e.totalCount}</h2>
                          </div>
                        </div>
                        <div className="row align-items-center m-b-15">
                          <div className="col-auto">
                            <h4 className={`m-b-0 text-c-${e.color}`}>{e.title}</h4>
                          </div>
                          <div className="col text-end">
                            <p className={`m-b-0 text-c-${e.color}`}>
                              <i className="feather icon-arrow-up m-r-10"></i>
                              {e.percentage}%
                            </p>
                          </div>
                        </div>
                        <div className="progress">
                          <div
                            className={`progress-bar bg-c-${e.color}`}
                            style={{
                              width: `${e.percentage}%`,
                            }}
                          ></div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>

          <MinMaxRate dash={data?.dash} />

          <div className="row">
            <div className="col-xl-9 col-md-9">
              <div className="card table-card">
                <div className="card-header">
                  <h5>Hydro Market</h5>
                </div>
                <div className="card-block">
                  <div className="table-responsive">
                    <table className="table table-hover table-sm m-b-0">
                      <thead>
                        <tr>
                          <th>Seller</th>
                          <th>Quantity</th>
                          <th>Amount</th>
                          <th>Type</th>
                          <th>Buyer</th>
                          <th>Status</th>
                        </tr>
                      </thead>
                      <tbody>
                        {data?.transaction?.map((e, k) => (
                          <tr key={k}>
                            <td>{e?.type === 'sell' ? e.user?.surname : e?.person?.surname}</td>
                            <td>{e?.quantity}</td>
                            <td>{e?.amount}</td>
                            <td>{renderStyle(e)}</td>
                            <td>{e?.type === 'buy' ? e.user?.surname : ''}</td>
                            <td>{renderStatus(e)}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xl-3 col-md-3">
              {data?.stats?.map((e, k) => (
                <div key={k} className="col-xl-12 col-md-12">
                  <div className="card proj-t-card">
                    <div className="card-body">
                      <div className="row align-items-center m-b-30">
                        <div className="col-auto">
                          <i className={`feather icon-${e.icon} text-c-${e.color} f-30`}></i>
                        </div>
                        <div className="col p-l-0">
                          <h6 className="m-b-5">{e.title}</h6>
                          <h3 className={`m-b-0 text-c-${e.color}`}>
                            <NumberFormatDecorator value={e.month_count} />
                          </h3>
                        </div>
                      </div>
                      <div className="row align-items-center text-center">
                        <div className="col">
                          <h3 className="m-b-0">
                            <NumberFormatDecorator value={e.totalCount} />
                          </h3>
                        </div>
                        {/* <div className="col">
												<i
													className={`feather icon-arrow-right text-c-${e.color} f-18`}
												></i>
											</div>
											<div className="col">
												<h6 className="m-b-0">{e.month}</h6>
											</div> */}
                      </div>
                      <h6 className={`pt-badge bg-c-${e.color}`}>{e.percentage}%</h6>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </>
      )}
    </MainPage>
  )
}

export const MinMaxRate = ({ dash }) => (
  <div className="row">
    {dash?.map((e) => (
      <div id={e.label} className="col-xl-3 col-md-3">
        <div className="card">
          <div className="card-block">
            <div className="row align-items-center">
              <div className="col">
                <h5 className="m-b-0">{e.label}</h5>
              </div>
              <div className="col-auto">
                <h3 className="m-b-0">{Number.parseFloat(e.value).toFixed(2)}</h3>
              </div>
            </div>
          </div>
        </div>
      </div>
    ))}
  </div>
)
